export enum ChatState {
  Listening = 'listening',
  Translating = 'translating',
  Speaking = 'speaking',
  Idle = 'idle',
  Transcribing = 'Transcribing'
}
